
import {FC} from "react";

import React from 'react';

import ErrorExistsThirdForm from "../../forms/claim-handling-forms/error-exists-third-form";

interface Interface{
    partSource: any;
    requestId: any;
    mode?: "View" | "Add new";
    onClose?: () => void;
}

const ErrorExistsThirdScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <ErrorExistsThirdForm
                    requestId={props.requestId}
                    partSource={props.partSource}
                    mode={props.mode}
                />
            
    );
}
export default ErrorExistsThirdScreen;
